goog.require('el8.template.multiuser_access.verificationCode');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.verificationCode = (function() {

    var that = {};
    var unauthUserId = null;
    var faxCode = null;
    var authToken = null;
    var faxVerId = null;
    var theForm = null;
    var faxNumber = null;

    function resendVerificationFax(faxCode, unauthUserId, authToken) {

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('requestFaxVerification', [faxCode, unauthUserId, authToken]),
            data: JSON.stringify({}),
            async: true,
            success: function(data) {
                if (!data.error) {
                    $('.resend-verification-fax').html('Verification Fax sent to ' + faxNumber + '.  It could take up to 5-10 minutes for the fax to arrive.');
                } else {
                    $('.resend-verification-fax').html('Verification Fax Request failed.  Please try again later or contact support@elationemr.com');
                }
            }
        });
    }

    function checkVerificationCode() {
        var verificationCode = theForm.getVal('verificationCode');

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('checkVerificationCode', [faxCode, unauthUserId, authToken]),
            data: JSON.stringify({
                code: verificationCode
            }),
            async: true,
            success: function(data) {
                if (!data.error) {
                    var url = el8.service.urls.get('pageUnauthUserPostVerificationTriage', [faxCode, unauthUserId, authToken, data.fax_verification_id, data.verification_token]);
                    location.href = url;
                } else {
                    $('.el8ErrorAlert').show();
                }
            }
        });
    }

    function inputChanged() {

       if (theForm.getVal('verificationCode')) {
           $('#submit-verification-code').prop('disabled', false);
       } else {
           $('#submit-verification-code').prop('disabled', true);
       }
    }

    var debouncedInputChanged = _.debounce(inputChanged, 250);


    function setupKeyPressedListeners() {
        $(document).on('keypress', ':input[name="verificationCode"]', debouncedInputChanged);
    }

    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */

        if (spec.urls) { el8.service.urls.init(spec.urls); }

        unauthUserId = spec.unauthUserId;
        faxCode = spec.faxCode;
        authToken = spec.authToken;
        faxNumber = spec.faxNumber;
        var faxRecipName = spec.faxRecipName;
        faxVerId = spec.faxVerId;

        $('.main-content').html(
            el8.template.multiuser_access.verificationCode.content({
                faxNumber: faxNumber,
                faxRecipName: faxRecipName
            })
        );

        theForm = new el8.uiwidget.Form({
            fields: [{
                name: 'verificationCode',
                selector: ':input[name="verificationCode"]',
                maxLength: 20,
                changeFn: function() {
                    inputChanged();
                }
            }],
            container: $('#main-form')
        });
        theForm.render();

        setupKeyPressedListeners();

        inputChanged();

        $('.el8ErrorAlert').hide();

        $(document).on('click', '#submit-verification-code', function() {
           checkVerificationCode(faxCode, unauthUserId, authToken);
        });

        $(document).on('click', '.resend-verification-fax', function(event) {
           resendVerificationFax(faxCode, unauthUserId, authToken);
           event.preventDefault();
           return false;
        });
    };

    return that;

})();
